module.exports = __webpack_public_path__ + "static/media/logo.2c306e3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 1360
// module chunks = 0